<template lang="html">
  <v-layout row wrap>
    <v-flex lg12>
      <v-layout column align-end class="mt-1 mb-1">
        <date-picker 
          v-model="time" 
          range
          confirm
          clear
          placeholder="Select a Date Range"
          input-name="time"
          :format="'DD-MM-YYYY'"
          @confirm="formatDates()"
        > </date-picker>
      </v-layout>
    </v-flex>
    <v-flex lg12 v-if="loadingStats">
      <v-layout column align-center class="mt-1 mb-1">
        <v-progress-circular
          :size="70"
          :width="7"
          color="blue"
          indeterminate
        ></v-progress-circular>
      </v-layout>
    </v-flex>
    <template v-else>
      <v-flex lg3 sm6 xs12>
      <mini-statistic
        icon="supervisor_account"
        :title="titleResponses"
        :sub-title="'Responses'"
        color="indigo lighten-4"
      ></mini-statistic>
    </v-flex> 
    <v-flex lg3 sm6 xs12>
      <mini-statistic
        icon="thumb_up_alt"
        :title="titleSentimentalRating"
        sub-title="Sentimental rating"
        color="purple lighten-4"
      ></mini-statistic>
    </v-flex>
    <v-flex lg3 sm6 xs12>
      <mini-statistic
        icon="network_check"
        :title="titleNps"
        sub-title="NPS"
        :color="stats.nps >= 0 ? 'light-green lighten-3' : 'red lighten-3'"
      ></mini-statistic>
    </v-flex>
    <v-flex lg3 sm6 xs12>
      <mini-statistic
        icon="devices"
        :title="titleDevices"
        :sub-title="'Devices (Groups)'"
        color="blue lighten-4"
      ></mini-statistic>
    </v-flex>
    <v-flex lg3 sm6 xs12>
      <mini-statistic
        icon="done_all"
        :title="titleCompleted"
        :sub-title="subTitleCompleted"
        color="green lighten-3"
      ></mini-statistic>
    </v-flex>
    <v-flex lg3 sm6 xs12>
      <mini-statistic
        icon="sentiment_very_dissatisfied"
        :title="titleDetractors"
        sub-title="Detractors"
        color="red lighten-3"
      ></mini-statistic>
    </v-flex>
    <v-flex lg3 sm6 xs12>
      <mini-statistic
        icon="sentiment_dissatisfied"
        :title="titlePassives"
        sub-title="Passive"
        text-no-wrap
        color="lime lighten-3"
      ></mini-statistic>
    </v-flex>
    <v-flex lg3 sm6 xs12>
      <mini-statistic
        icon="sentiment_very_satisfied"
        :title="titlePromotors"
        sub-title="Promotors"
        color="green lighten-3"
      ></mini-statistic>
    </v-flex>
    </template>
    
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex';
import DatePicker from 'vue2-datepicker';
import moment from 'moment';
import MiniStatistic from '@/components/widgets/statistic/MiniStatistic';
export default {
  components: {
    MiniStatistic,
    DatePicker
  },
  props: {
    round_id: {
      type: String,
      required: true
    }
  },
  
  data () {
    return {
      stats: {},
      time: ['empty', 'empty'],
      datesValues: [moment(new Date()).format('YYYY-MM-DD'), moment(new Date()).format('YYYY-MM-DD')],
      loadingStats: true

    };
  },
  computed: {
    ...mapGetters('survey', ['selectedSurvey']),
    titleResponses: function () {
      return this.stats.total_responses ? `${this.stats.total_responses}` : '0';
    },
    titleSentimentalRating: function () {
      return this.stats.sentimental_rating ? `${this.stats.sentimental_rating} %` : '0 %';
    },
    titleNps: function () {
      return this.stats.nps ? `${this.stats.nps}` : '0';
    },
    titleDevices: function () {
      return this.stats.total_devices ? `${this.stats.total_devices}(${this.stats.total_groups})` : '0 (0)';
    },
    titleCompleted: function () {
      return this.stats.total_completed ? `${this.stats.total_completed}` : '0';
    },
    subTitleCompleted: function () {
      return this.stats.average_completed ? `Completed ${this.stats.total_completed}(${this.stats.average_completed}%)` : 'Completed 0 (0%)';
    },
    titleDetractors: function () {
      return this.stats.detractors ? `${this.stats.detractors}` : '0';
    },
    titlePassives: function () {
      return this.stats.passives ? `${this.stats.passives}` : '0';
    },
    titlePromotors: function () {
      return this.stats.promotors ? `${this.stats.promotors}` : '0';
    }
  },
  mounted () {
    this.loadData();
  },
  methods: {
    loadData () {
      const survey_id = this.selectedSurvey.id;
      const round_id = this.round_id;
      const url = `rounds/${round_id}/stats-devices/${this.datesValues[0]}/${this.datesValues[1]}`;
      this.loadingStats = true;
      
      window.axios.get(url).then(response => {
        this.stats = response.data.data;
        this.loadingStats = false;
      });
    },
    formatDates () {
      if (this.time[0] !== 'empty' && this.time[1] !== 'empty') {
        this.datesValues[0] = moment(this.time[0]).format('DD-MM-YYYY');
        this.datesValues[1] = moment(this.time[1]).format('DD-MM-YYYY');
        this.$emit('dates', this.datesValues);
      }
      this.loadData();
    }
  }
};
</script>
<style>
  .caption{
    font-weight: 400px;
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/components/client/rounds/stats/StatsDevices.vue